import { createApp } from 'vue'
import axios from 'axios'
import router from '@/router';
import { ElMessage, ElMessageBox } from 'element-plus'
const app = createApp()
// export const BASE_URL = 'http://192.168.1.76:8080'
export const BASE_URL = 'https://www.ldils.com/'
const service = axios.create({
  // baseURL: process.env.VUE_APP_API_ROOT,
  baseURL: BASE_URL,
  // baseURL: 'https://www.ldils.com/',
  timeout: 10000 // request timeout
})
service.interceptors.request.use(
  (config) => {
    const requestHeader = {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    }
    config.headers = requestHeader
    config.headers.Authorization = window.localStorage.getItem('xx_TOKENOne') || ''
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// response interceptor 响应拦截器
service.interceptors.response.use(
  (response) => {
    if (response.data?.resultCode == 10001) {
      
      localStorage.removeItem('xx_TOKENOne');
      localStorage.removeItem('phone');
      ElMessageBox.confirm(
        '你还未登录，是否去登陆?',
        '用户未登录!',
        {
          confirmButtonText: '登录',
          cancelButtonText: '取消',
          type: 'none',
        }
      )
        .then(() => {
          router.push({
            path: "/logIn",
            query: {
              activeTab: 0
            },
          });
        })
        .catch(() => {

        })
      return response.data
    } else {
      return response.data
    }
    console.log(response, "asajsjjoiqwoiqwiooi");

  },
  (error) => {
    console.log(error, "shibai");
    return error.response
  }
)
export default service
